import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import Stats from "../components/landing/Stats";
import Audience from "../components/landing/Audience";
import BmiCalculator from "../components/landing/BmiCalculator";
import Method from "../components/landing/Method";
import PhotoGallery from "../components/landing/PhotoGallery";
import VideoGallery from "../components/landing/VideoGallery";
import BeforeAfter from "../components/landing/BeforeAfter";
import Testimonials from "../components/landing/Testimonials";
import Included from "../components/landing/Included";
import Bonus from "../components/landing/Bonus";
import Pricing from "../components/landing/Pricing";
import About from "../components/landing/About";
import LeadCapture from "../components/landing/LeadCapture";
import Guarantee from "../components/landing/Guarantee";
import FAQ from "../components/landing/FAQ";
import ExternalLinks from "../components/landing/ExternalLinks";
import Footer from "../components/landing/Footer";
import WhatsAppFloat from "../components/landing/WhatsAppFloat";
import StickyCta from "../components/landing/StickyCta";
import CookieConsent from "../components/landing/CookieConsent";
import SiteHead from "../components/landing/SiteHead";

export default function Landing() {
  const [content, setContent] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get("/content").then((res) => setContent(res.data)).catch((e) => setError(e.message));
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center text-onyx">
        <div data-testid="landing-error">Erro ao carregar: {error}</div>
      </div>
    );
  }
  if (!content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-alabaster">
        <div data-testid="landing-loading" className="font-serif text-2xl text-onyx">Carregando…</div>
      </div>
    );
  }

  const v = content.visibility || {};
  const show = (k) => v[k] !== false; // default true if missing

  return (
    <div data-testid="landing-page" className="bg-alabaster text-onyx min-h-screen">
      <SiteHead seo={content.seo} tracking={content.tracking} brand={content.brand} />
      <Navbar brand={content.brand} whatsapp={content.whatsapp} content={content} />
      {show("hero") && <Hero data={content.hero} content={content} />}
      {show("stats") && <Stats data={content.stats} />}
      {show("audience") && <Audience data={content.audience} />}
      {show("bmiCalculator") && <BmiCalculator data={content.bmiCalculator} content={content} />}
      {show("method") && <Method data={content.method} />}
      {show("photoGallery") && <PhotoGallery data={content.photoGallery} />}
      {show("videoGallery") && <VideoGallery data={content.videoGallery} />}
      {show("beforeAfter") && <BeforeAfter data={content.beforeAfter} />}
      {show("testimonials") && <Testimonials data={content.testimonials} />}
      {show("included") && <Included data={content.included} />}
      {show("bonus") && <Bonus data={content.bonus} />}
      {show("pricing") && <Pricing data={content.pricing} content={content} />}
      {show("about") && <About data={content.about} />}
      {show("leadCapture") && <LeadCapture data={content.leadCapture} />}
      {show("guarantee") && <Guarantee data={content.guarantee} content={content} />}
      {show("faq") && <FAQ data={content.faq} />}
      {show("externalLinks") && <ExternalLinks data={content.externalLinks} />}
      <Footer data={content.footer} brand={content.brand} />
      {show("whatsappFloat") && <WhatsAppFloat whatsapp={content.whatsapp} />}
      {show("stickyCta") && <StickyCta data={content.stickyCta} content={content} />}
      {show("cookieConsent") && <CookieConsent data={content.cookieConsent} />}
    </div>
  );
}
